import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { enableScrollJs, disableScrollJs } from '../../helpers/scroll';
import * as page from '../../reducers/pageReducer';

import './modal.css';

const portalRoot = document.getElementById("portal");

class Modal extends Component {
  constructor() {
    super();
    this.el = document.createElement("div");
  }
  
  state = {
      isOverlay: true,
  }

  componentWillUnmount = () => {
    portalRoot.removeChild(this.el);
    enableScrollJs();
  };

  componentWillMount() {
      const { scrollable } = this.props;
      
      portalRoot.appendChild(this.el);

      if(!scrollable) {
          disableScrollJs();
      }
      /* if menu opened, do not add another overlay */
      if (this.isMenuOpened() || this.props.noOverlay) {
          this.setState({isOverlay: false})
      }
  }

  isMenuOpened = () => {
    return this.props.pageType === 'MENU_PAGE'
  }

  render() {
    const props = this.props;
    const overlayTop = props.overlayTop ? props.overlayTop : 0;
    const onClose = props.closeOnOutsideClick || props.closeOnOverlayClick ? props.onClose : () => {};
    const paddingTop = props.paddingTop ? props.paddingTop : '65px';
    const modalStyle = {  top:paddingTop, left: 0, right: 0, ...this.props.style };
    
    if (props.scrollable) {
      modalStyle.height = '100%';
    }

    return (
      ReactDOM.createPortal(
        <div className="portal_wrapper">
            <div onClick={onClose} className="modal-overlay" style={{top: overlayTop, opacity: !this.state.isOverlay ? '0' : '1.0' }}></div> 
              <div className={`modal_wrapper ${props.raisedClass || ''}`} style={modalStyle}>
              {props.children}
            </div>
        </div>,
        this.el,
      )
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const raisedClass = state.modal.modalProps.raisedClass;

  return {
    raisedClass,
    scrollable: ownProps.scrollable,
    router : state.router,
    modalType: state.modal.modalType,
    isMenuOpened: state.menu.isMenuOpened,
    isPageOpened: page.isPageOpened(state),
    pageType: state.page.pageType,
  };
};


export default connect(mapStateToProps, null)(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx